module.exports = __webpack_public_path__ + "static/media/hackers_garbage.77fe0ead.gif";